import { useMsal } from "@azure/msal-react";
import { UserRole } from "../utils";

const useUserRole = () => {
  const { instance } = useMsal();
  const activeAccount = instance && instance.getActiveAccount();

  const userRole = activeAccount?.idTokenClaims?.extension_ilpr as UserRole;

  return userRole;
};

export default useUserRole;
